export default __webpack_public_path__ + "static/5-5279260013ef9e453de1437c13472aac.jpeg";